import React from 'react';
import { Routes, Route } from "react-router-dom";
import { Contact, Home, PageNotFound, Location, Services, ServiceDetail, Realisation, MentionLegale } from '../pages/index';

export const AllRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nos-services" element={<Services />} />
            <Route path="/nos-services/:id" element={<ServiceDetail />} />
            <Route path="/nos-realisations" element={<Realisation />} />
            <Route path="/location" element={<Location />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mention-legale" element={<MentionLegale />} />

            <Route path="*" element={<PageNotFound />} />
        </Routes>
    )
}